<template>
	<div>
		<!-- Start of linking-map Zendesk Widget script -->

		<!-- <script v-if="user && user.role === 'client'"
			id="ze-snippet"
			type="application/javascript"
			src="https://static.zdassets.com/ekr/snippet.js?key=551eeb72-2f17-49da-8f2c-cdb0f3656095">
		</script> -->
		
		<!-- End of linking-map Zendesk Widget script -->
		<div @click="toggle" v-on-clickaway="away">
			<div class="half">
				<label for="profile2" class="profile-dropdown">
				<input type="checkbox" id="profile2" />
				<img
					src="../../assets/static/avatars/client.png"
				/>
				<span>{{ clientName }}</span>
				<label for="profile2" data-qa="clientDropdown">
					<i class="mdi mdi-chevron-down"></i>
				</label>
				<ul>
					<li class="center">
						<a @click="goTo('/dashboard/settings/')" data-qa="settingsButton">
							<font-awesome-icon class="icon mg-r14" icon="cogs" />
							{{ $t('settings') }}
						</a>
					</li>
					<li class="center">
						<a @click="logout" data-qa="logoutButton">
							<font-awesome-icon class="icon mg-r15" icon="sign-out-alt" />
							{{ $t('logout') }}
						</a>
					</li>
					<li class="ctaButton" v-if="subscriptionDetails.status === 'trial' && subscriptionDetails.activeUnit > 0">
						<a style="text-align: left;" @click="openCreditCardForm('addition')" data-qa="addPaymentButton">
							<font-awesome-icon class="icon mg-r15" icon="credit-card" />
							{{$t('addPaymentCard')}}
						</a>
					</li>
					<li class="ctaButton" v-if="subscriptionDetails.status === 'active'">
						<a style="text-align: left;" @click="openCreditCardForm('updation')" data-qa="chargeCardButton">
							<font-awesome-icon class="icon mg-r15" icon="credit-card" />
							{{$t('changeCardDetails')}}
						</a>
					</li>
					<li class="ctaButton" v-if="subscriptionDetails.status === 'active'">
						<a style="text-align: left;" @click="$bvModal.show('cancel-subscription-modal')" data-qa="cancelPlanButton">
							<font-awesome-icon class="icon mg-r15" icon="credit-card" />
							{{$t('unsubscribe')}}
						</a>
					</li>
					<li class="lang-dashboard">
						<a data-qa="languageButton">
							<language-switcher />
						</a>
					</li>
				</ul>
				</label>
				<!--dropdown end-->
			</div>
			<div class="content">
				<b-modal id="subscription-modal" size="lg" hide-footer>
					<template v-slot:modal-title data-qa="choosePlanTitle">
						{{ $t('subscribeYourPlan') }}
					</template>
					<SubscriptionTable
						:subscriptionData="subscriptionDetails"
						@subscribe-success="closeModal"/>
				</b-modal>
				<b-modal id="creditcard-modal" size="lg" hide-footer>
					<template v-slot:modal-title>
						<!-- {{ $t('changePlan') }} -->
					</template>
			<CreditCardForm
			:action="creditCardAction"
			:subscription="subscriptionDetails"
			@subscribe-success="closeCreditCardModal"
			></CreditCardForm>
				</b-modal>
		<b-modal id="cancel-subscription-modal" size="sm" hide-header @ok="unsubscribePlan()">
			<h5>{{ $t('cancelSubcriptionQ') }}</h5>
		</b-modal>
		<sweet-modal icon="success" ref="modalSuccess" name="successModal">
			{{ $t('confirmedSubscription') }}
			<br/>
		</sweet-modal>
		<sweet-modal icon="success" ref="modalCardSuccess" name="cardSuccessModal">
			{{ $t('creditCardChangeSuccess') }}
			<br/>
		</sweet-modal>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { mixin as clickaway } from 'vue-clickaway'
import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue'
import CreditCardForm from '@/components/forms/CreditCardForm.vue'

// import SubscriptionTable from '@/components/ui/SubscriptionTable.vue'
import ClientService from '@/services/ClientService.js'

export default {
  name: 'ProfileDropdown',
  components: {
    LanguageSwitcher,
	CreditCardForm
    // SubscriptionTable,
  },
  mixins: [clickaway],
  provide() {
    return {
      sharedState: this.sharedState,
    }
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      sharedState: {
        active: false,
      },
      imageUrl: null,
      subscriptionDetails: {},
      daysRemaining: 1, // trial days
      isSubscriptionDone: false,
      baseUrl: process.env.VUE_APP_API_URL,
      clientName: '',
      creditCardAction: null
    }
  },
  computed: mapState(['client']),
  methods: {
    goTo(path) {
      this.$router.push({ path: path + this.$i18n.locale })
    },
    openTicket() {
      // window.zE('webWidget', 'show')
    },
    toggle() {
      this.sharedState.active = !this.sharedState.active
    },
    away() {
      this.sharedState.active = false
      document.getElementById('profile2').checked = false
    },
    logout() {
      this.$router.push({ path: '/signedOut/' + this.$i18n.locale })
      this.$store.dispatch('logout')
    },
    fetchClientDetails() {
      ClientService.getClientDetails()
        .then((response) => {
          this.imageUrl =
            response.data && response.data.length > 0
              ? response.data[0].img_path
              : null
        })
        .catch((error) => {
          const notification = {
            type: 'error',
            message:
              'There was a problem fetching client details: ' + error.message,
          }
          this.$store.dispatch('notification/add', notification, { root: true })
        })
    },
    calculateRemainingDay() {
      const oneDay = 24 * 60 * 60 * 1000 // hours*minutes*seconds*milliseconds
      if (this.subscriptionDetails) {
        const freeTrialStartDate = new Date(
          this.subscriptionDetails['free_trial_start_date']
        )
        const todayDate = new Date()

        this.daysRemaining =
          30 - Math.round(Math.abs((todayDate - freeTrialStartDate) / oneDay)) // Here 30 is trial days
      }
    },
    async closeModal() {
      this.$bvModal.hide('subscription-modal')
      this.$root.$emit('updateSubscriptionDetails')
      this.isSubscriptionDone = true
      this.subscriptionDetails = await this.$store.dispatch(
        'fetchSubscriptionDetails'
      )
    },
    async closeCreditCardModal(subscriptionDetails) {
      this.$bvModal.hide('creditcard-modal')
      this.$root.$emit('updateSubscriptionDetails')
      this.isSubscriptionDone = true
      if (subscriptionDetails.status === 'active' && this.creditCardAction === 'addition') this.$refs.modalSuccess.open()
      else if (subscriptionDetails.status === 'active' && this.creditCardAction === 'updation') this.$refs.modalCardSuccess.open()
      else if (subscriptionDetails.status === 'incomplete') alert(this.$t('verifyCard'))
      this.subscriptionDetails = await this.$store.dispatch(
        'fetchSubscriptionDetails'
      )
    },
    async unsubscribePlan() {
      await this.$store.dispatch('deleteSubscription')
      this.$bvModal.show('cancel-subscription-feedback')
    },
    openCreditCardForm(action) {
      this.creditCardAction = action
      this.$bvModal.show('creditcard-modal')
    }
  },
  async mounted() {
    this.subscriptionDetails = await this.$store.dispatch(
      'fetchSubscriptionDetails'
    )
    if (this.subscriptionDetails.status === 'canceled' && new Date() < new Date(this.subscriptionDetails.current_period_end)) {
      this.isSubscriptionDone = true
    } else {
      this.subscriptionDetails.status === 'active'
        ? (this.isSubscriptionDone = true)
        : this.calculateRemainingDay()
    }
    this.fetchClientDetails()
    const user = JSON.parse(localStorage.getItem('user'))
    this.clientName = user
      ? `${user.firstName} ${user.lastName[0].toUpperCase()}.`
      : 'Client'
  },
}
</script>

<style lang="scss" scoped>
$border-radius: 3px;
$primary: #ced5da;
$animation: pulse;

.lang-dashboard {
//   background-color: var(--bg);
}

.ctaButton {
  background-color: var(--primaryDark) !important;
  text-align: center !important;
}
.center {
  text-align: left;
}
.ctaButton:hover {
  background-color: var(--bg-light) !important;
}

.orderBtn {
  text-align: left;
  margin-left: 28px;
}

.trialInfo {
  text-align: left;
}

.mg-r15 {
  margin-right: 10px;
}
.mg-r14 {
  margin-right: 6px;
}

.profile-dropdown {
  display: inline-block;
  position: absolute;
  right: 20px;
  top: 10px;
  background: var(--bg-ultraLight);
  margin: auto;
  font-weight: bold;
  font-size: 1rem;
  border-radius: $border-radius;
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none; /* Firefox all */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Likely future */

  * {
    -webkit-user-select: none; /* Chrome all / Safari all */
    -moz-user-select: none; /* Firefox all */
    -ms-user-select: none; /* IE 10+ */
    user-select: none; /* Likely future */
  }

  input[type='checkbox'] {
    display: none;
    &:checked {
      & ~ ul {
        display: block;
        animation: $animation 0.5s;
      }

      & ~ img {
        background: var(--bg);
      }

      & ~ label {
        background: var(--bg);

        i {
          color: var(--bg-ultraLight);
        }

        &:after {
          content: '';
          position: absolute;
          top: 100%;
          right: calc(50% - 10px);
          display: block;
          border-style: solid;
          border-width: 7px 10px 0 10px;
          border-color: var(--bg) transparent transparent transparent;
          width: 0;
          height: 0;
        }
      }
    }
  }

  img {
    display: inline-block;
    background: darken($primary, 10%);
    height: 2.5rem;
    vertical-align: middle;
    margin-right: 1rem;
    margin: 0.5rem 0.75rem 0.5rem 0.5rem;
    border-radius: 50%;
  }

  span {
    display: inline-block;
    vertical-align: middle;
    // width: 125px;
    // margin-right:2rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  ul {
    display: none;
    list-style: none;
    padding: 0;
    margin: 0;
    background: #fff;
    position: absolute;
    top: 100%;
    right: 0;
    text-align: left;
    width: 100%;
    border-radius: $border-radius;

    li {
      a {
        display: block;
        padding: 0.75rem 1rem;
        text-decoration: none;
        color: var(--bg) !important;
        font-size: 1rem;

        i {
          font-size: 1.3rem;
          vertical-align: middle;
          margin: 0 0.75rem 0 -0.25rem;
        }

        &:hover {
          color: var(--primary) !important;
        }
      }

      &:first-child a:hover {
        border-radius: $border-radius $border-radius 0 0;
      }

      &:last-child a:hover {
        border-radius: 0 0 $border-radius $border-radius;
      }
    }
  }

  & > label {
    position: relative;
    height: 3rem;
    display: block;
    text-decoration: none;
    background: transparent;
    color: #333;
    box-sizing: border-box;
    padding: 0.35rem;
    float: right;
    border-radius: 0 $border-radius $border-radius 0;

    i {
      color: darken($primary, 25%);
      font-size: 1.75rem;
    }
  }

  &:after {
    content: '';
    display: table;
    clear: both;
  }
}

/// TEMPLATE STYLING
$background: #2c3e50;

body {
  background: $background;
  font-family: Lato;
}

h1 {
  text-align: center;
  font-size: 3rem;
  color: rgba(0, 0, 0, 0.5);
  text-transform: uppercase;
  margin: 2rem 0 0;
  letter-spacing: 0.5rem;
}

.container {
  width: 80%;
  margin: 4rem auto 2rem;

  .half {
    width: 50%;
    float: left;
    margin-bottom: 2rem;
  }

  &:after {
    content: '';
    display: table;
    clear: both;
  }
}

p.subtitle {
  color: rgba(0, 0, 0, 0.5);
  font-weight: bold;
  text-align: center;
  margin: 0.5rem 0 2rem;
  letter-spacing: 0.1rem;
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0.25;
  z-index: -1;
  background: url(https://ar1web-com.googlecode.com/svn/Bg/bg63.gif);
}

@media screen and (min-width: 1000px) {
  .profile-dropdown {
    min-width: 200px;
  }
}

@media screen and (min-width: 551px) {
  .profile-dropdown {
    min-width: 180px;
  }
}

@media screen and (max-width: 550px) {
  .profile-dropdown ul li a {
    font-size: 0.8rem;
    padding: 0.45rem 0.5rem;
  }
  .profile-dropdown span {
    display: none;
    margin: 10px 0px 2px 5px;
  }
  .profile-dropdown img {
    padding: 0.3rem;
    margin: 8px 0px 0px 4px;
    height: 2.5rem;
  }
  .profile-dropdown ul {
    width: 140%;
  }
  .profile-dropdown label {
    margin-top: 5px;
  }
  .profile-dropdown {
    right: 3px;
    background: none;
	min-width: 100px;
  }
  .mg-r15 {
  margin-right: 8px;
}
  .mg-r14 {
  margin-right: 5px;
}
}
</style>